import uiReducer from './reducer';
export * from './types';

export default uiReducer;
